import { experimentalRichEditPolicy, type RichEditSkin, type RichEditVariant } from '@/app/richEdit'

export const MAILBOX_RICH_EDIT_VARIANT: RichEditVariant = 'std'
export const RICH_EDIT_POLICY = experimentalRichEditPolicy(MAILBOX_RICH_EDIT_VARIANT)

export const mailboxRichEditSkin: RichEditSkin = {
  root: 'flex min-h-0 flex-1 flex-col',
  modeBar: 'flex min-h-11 flex-wrap items-center gap-2 border-b border-[#d9e1e8] bg-[#f8fafb] px-4 py-1.5',
  modeButton: 'h-7 rounded border border-[#c8d2dc] bg-white px-2 text-xs font-medium text-[#314253] hover:bg-[#edf2f6]',
  modeButtonActive: 'h-7 rounded border border-[#2b6cb0] bg-[#e8f1fa] px-2 text-xs font-medium text-[#2b6cb0]',
  toolbar: 'flex flex-wrap items-center gap-2 border-b border-[#d9e1e8] bg-[#f8fafb] px-4 py-1.5',
  toolbarGroup: 'flex flex-wrap items-center gap-1',
  button: 'flex h-7 min-w-7 items-center justify-center rounded border border-[#c8d2dc] bg-white px-2 text-xs text-[#314253] hover:bg-[#edf2f6] disabled:opacity-40',
  buttonActive: 'border-[#2b6cb0] bg-[#e8f1fa] text-[#2b6cb0]',
  select: 'h-7 rounded border border-[#c8d2dc] bg-white px-2 text-xs text-[#314253]',
  color: 'h-7 w-8 rounded border border-[#c8d2dc] bg-white p-0.5',
  surfaceWrap: 'min-h-0 flex-1',
  surface: 'box-border h-full min-h-[360px] w-full overflow-auto bg-white px-6 py-5 text-sm leading-6 text-[#26323d] outline-none [&_a]:text-[#1f62a6] [&_img]:max-w-full [&_table]:border-collapse [&_td]:p-1',
  status: 'ml-auto text-[11px] text-[#687684]',
  blocks: {
    toolbar: 'flex flex-wrap gap-1 border-b border-[#d9e1e8] bg-[#f8fafb] px-4 py-1.5',
    stage: 'relative min-h-[360px] overflow-auto bg-[#eef2f5]',
    block: 'absolute overflow-hidden rounded border border-[#c8d2dc] bg-white shadow-sm',
    blockSelected: 'border-[#2b6cb0] ring-2 ring-[#2b6cb0]/20',
    blockContent: 'h-full overflow-auto p-3 text-sm outline-none',
    handle: 'pointer-events-none absolute bottom-0 right-0 bg-[#2b6cb0] px-1 text-xs text-white',
    empty: 'flex min-h-[360px] items-center justify-center text-sm text-[#687684]',
  },
  canvas: {
    toolbar: 'flex flex-wrap gap-1 border-b border-[#d9e1e8] bg-[#f8fafb] px-4 py-1.5',
    stage: 'min-h-[360px] overflow-auto bg-[#e7ebef] p-3',
    viewport: 'mx-auto w-fit bg-white shadow-sm',
    fallback: 'mx-auto max-w-full bg-white [&_svg]:max-w-full',
  },
}
